const ICO_VER = { ticket: '3', bell: '1', bag: '4', key: '1' };

const Ico3 = ({ name, className = 'w-6 h-6' }) => (
  <img src={`/icons3d/${name}.png${ICO_VER[name] ? `?v=${ICO_VER[name]}` : ''}`} alt="" draggable={false} className={`${className} object-contain shrink-0`} />
);

export const PointsMark = ({ value, prefix = '', size = 'w-5 h-5', className = '' }) => (
  <span className={`inline-flex items-center gap-1.5 min-w-0 ${className}`}>
    <Ico3 name="coins" className={size} />
    <span className="font-semibold tabular-nums tracking-tight truncate">
      {prefix}
      {typeof value === 'number' ? value.toLocaleString('tr-TR') : value}
    </span>
  </span>
);

export default Ico3;
